export default __webpack_public_path__ + "static/media/Guests.4412965d.svg";